"use client";

import type { ReactNode } from "react";

import { QueryLink } from "@/components/queryLink/queryLink.component";

/**
 * Inline rich-text control that sets a query param while preserving the rest of the URL.
 */
export function RichTextInteractiveQueryLink({
  param,
  value,
  children,
  "aria-label": ariaLabel,
}: RichTextInteractiveQueryLinkProps) {
  return (
    <QueryLink
      set={{ [param]: value }}
      className="underline"
      aria-label={ariaLabel}>
      {children}
    </QueryLink>
  );
}

export type RichTextInteractiveQueryLinkProps = {
  /** Query parameter name (e.g. shop `drawer`). */
  param: string;
  /** Value stored in a Sanity `documentAction.modal` reference. */
  value: string;
  children?: ReactNode;
  "aria-label"?: string;
};
